'use client';

import { useUtmTracking } from '@/hooks/useUtmTracking';

const UtmTracker = () => {
	useUtmTracking();

	return null;
};

export default UtmTracker;
